module.exports = __webpack_public_path__ + "img/Picture17.8a3bb9a1.png";